import { CircleHelp, Bug, Lightbulb } from "lucide-react";
import type { FieldValues, FieldPath } from "react-hook-form";
import { CardGroupField } from "@/components/form/CardGroupField";
import type { CardOption } from "@/components/ui/CardGroupInput";
import type { IssueTypeId } from "../hooks/useFeedbackForm";

export const ISSUE_TYPE_OPTIONS = [
  { id: "question", icon: CircleHelp, title: "Question" },
  { id: "issue", icon: Bug, title: "Issue" },
  { id: "idea", icon: Lightbulb, title: "Idea" },
] satisfies CardOption<IssueTypeId>[];

interface IssueTypeFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> {
  name: TName;
  label?: string;
  onAfterChange?: (value: string) => void;
  testIdPrefix?: string;
}

export function IssueTypeField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, label = "type", onAfterChange, testIdPrefix }: IssueTypeFieldProps<TFieldValues, TName>) {
  return (
    <CardGroupField
      name={name}
      label={label}
      options={ISSUE_TYPE_OPTIONS}
      onAfterChange={onAfterChange}
      testIdPrefix={testIdPrefix}
    />
  );
}
